import { ResourceUUIDVersionIdentifier } from 'src/app/common/model/resource-id-version-identifier';


export class SetOfColumns {
    id: string;
    name: string;
    version: number;
    type: SetOfColumnsType;
    fields: ColumnState[];

    getVersionId(): ResourceUUIDVersionIdentifier {
        return new ResourceUUIDVersionIdentifier(this.id, this.version);
    }

}

export class ColumnState {
    constructor(public columnName: string, public position: number, public width: any) { }
}

export enum SetOfColumnsType {
    GENERAL = 'GENERAL',
    USER = 'USER'
}
